const instance = process.env.REACT_APP_INSTANCE

export const instanceIs = i => i === instance
